export default "__VITE_ASSET__CGCMHl4A__"